<section class="db-approve-contact-info-edit-modal">
  <div class="approve-header" [innerHTML]="modalValue.title">
  </div>
  <div class="approve-message mt10" [innerHTML]="modalValue.message">
  </div>
  <div class="approve-subMessage mt10" [innerHTML]="modalValue.subMessage">
  </div>
  <div class="approve-warning ds-notification-gray mt20" *ngIf="modalValue.warning">
    <i class="db-icon db-icon-ds-info-bg mr5"></i>
    <span [innerHTML]="modalValue.warning"></span>
  </div>
  <div class="approve-actions mt20">
    <button class="ds-btn-black" (click)="activeModal.close()">
      <span>{{"text_gotIt"|dbText}}</span>
    </button>
  </div>
</section>
